import styled from "styled-components";

import colors from "../../assets/css/colors";

export const Container = styled.div`
    background: ${colors.grayLightest} 0% 0% no-repeat padding-box;
    border-radius: 27px;
    padding: 20px 32px;
    margin-top: 38px;
`

export const Title = styled.span`
    font: normal normal normal 16px Circular Std Book;
    color: ${colors.tertiary};
`

export const BalanceAndTransferContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 15px;
    margin-bottom: 10px;
    height: 26px;
`

export const BalanceCurrecy = styled.div`
    display: flex;
    align-items: flex-end;
    margin-right: 3px;
    font: normal normal 300 15px Muli;
    color: ${colors.primary};
`

export const BalanceValue = styled.div`
    line-height: 0.8 !important;
    font: normal normal 600 20px Muli;
    color: ${colors.primary};
`

export const Button = styled.button`
    border: 0;
    outline: none;
    border-radius: 0;
    padding: 5px 10px;
    font-size: 10px;
    width: 115px;
    font-weight: 600;
    border-radius: 6px;
    background: ${colors.primary};
    color: ${colors.white};
    transition: all.5s ease;

    -webkit-box-shadow: -4px 17px 50px -26px rgba(238, 168, 73, 1);
    -moz-box-shadow: -4px 17px 50px -26px rgba(238, 168, 73, 1);
    box-shadow: -4px 14px 50px -15px rgba(238, 168, 73, 1);

  
    &:hover {
        background: ${colors.quaternary};
    }

    &:focus {
        background: ${colors.quaternary};
        outline:none !important;
    }

    @media (max-width: 500px) {
        width: 105px;
    }
`

export const PostScriptum = styled.span`
    font: normal normal 300 12px Muli;
    color: ${colors.grayDark};
`